import type { FeatureSetting } from '@/features/feature-management/types/featureSetting';

export const DEFAULT_POLL_FEATURE_VALUES: PollFeature['featureValues'] = {
  maxNumberCharsPollText: 60,
  maxNumberCharsPollOptionText: 120,
  maxPollDurationMilliseconds: 1_209_600_000
};

export type PollFeature = Omit<FeatureSetting, 'featureValues'> & {
  featureValues: {
    maxNumberCharsPollText: number;
    maxNumberCharsPollOptionText: number;
    maxPollDurationMilliseconds: number;
  };
};
